<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("genre", 2) }}
      </div>
      <router-link class="btn-blue" to="genres"
        >{{ $tc("genre", 1) }} {{ $tc("list", 1) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Genre"
          :key="index"
          v-if="item.fieldname !== 'g_id'"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div v-if="item.fieldname !== 'g_is_active' && item.fieldname !== 'visible_on_website'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                  v-b-tooltip.hover.top="$t(item.tooltip)"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span>
            </p>
          </div>
          <div v-if="item.fieldname === 'g_is_active'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                v-model="item.fieldvalue"
              />
              <!-- <span class="switch-slider"></span>
              </label> -->
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>

          <div v-if="item.fieldname === 'visible_on_website'">
              <div class="d-flex align-items-center">
                <label class="mb-0 mr-3">{{ $t("Visible On Website") }}</label>
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox"
                  unchecked-value="N"
                  value="Y"
                  v-model="visible_on_website" 
                />
              </div>
            </div>
        </div>
        
        <div class="col-12">
          <TranslationsContainer :translationsObj="translationsObj" />
        </div>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onUpdateHandler"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <button @click.prevent.stop="resetHandler()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="genres">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Genre from "@/helper/formJSONMaster/Genre";
import TranslationsContainer from "@/components/Partials/translationsFields.vue";

export default {
  components: {
    TranslationsContainer,
  },
  data() {
    return {
      btenable: false,
      Genre: Genre.ms_genre,

      Methods: Genre.Methods,
      submitted: false,
      translationsObj: {},
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.getEditList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    resetHandler: function () {
      this.Genre.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    getEditList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("data :");
            let obj = data.details[0];
            this.Genre.map((x) => {
              if (x.fieldname === "g_is_active") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
            this.visible_on_website = obj.visible_on_website === "Y" ? "Y" : "N";
            if (obj.translationsObj) {
              this.translationsObj = obj.translationsObj;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    checkDuplicateGOrder (g_order){
      return MasterService.checkGOrderExists(g_order).then((response)=>{
        return response.data.exists
      })
    },
    onUpdateHandler: function () {
      // let body = this.getRequestBody("PUT", this.Genre, {
      //   ...this.Methods,
      //   params: { id: this.$route.query.id }
      // });
      // MasterService.GlobalRequest(body)
      //   .then(response => {
      //     const { data } = response;
      //     if (data.status) {
      //       console.log("here :", data);
      //       this.$router.push({
      //         path: "/master/genres"
      //       });
      //     } else {
      //       console.log("show error :", data.message);
      //     }
      //   })
      //   .catch(error => {
      //     console.log("show error :", error);
      //   });
      console.log("translationsObj: ", this.translationsObj);

      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          this.btenable = true;
          console.log("valid :", valid);
          const g_order = this.Genre.find(
            (item) => item.fieldname === 'g_order'
          ).fieldvalue;

          this.checkDuplicateGOrder(g_order).then((isDuplicate)=>{
            if(isDuplicate){
              this.$toasted.show(
                "The Order Number Is Already In Use. Please Choose Another Number"
              );
              this.btenable = false;
            }else{
              let body = this.getRequestBody("PUT", this.Genre, {
            ...this.Methods,
            params: { id: this.$route.query.id },
          });

          body.payload = {
            ...body.payload,
            translationsObj: this.translationsObj,
            visible_on_website: this.visible_on_website,
          };

          console.log("body :", body);

          MasterService.GlobalRequest(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;

              if (data.status) {
                console.log("here :", data);
                this.$router.push({
                  path: "/master/genres",
                });
              } else {
                // console.log("show error :", data.message);
                // this.$toasted.show(Error(data.message));
                // this.$toasted.show("This record is already present ");
                this.$toasted.show(data.error.sqlMessage);
              }
            })
            .catch((error) => {
              console.log("show error2 :", error);
            });
            }
          })
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/GenreComponents/editGenre.vue